// extracted by mini-css-extract-plugin
export default {"tooltip":"InfoTooltip_tooltip__pM4rd","tooltipTrigger":"InfoTooltip_tooltipTrigger__E2xim"};